var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Lingallery',{attrs:{"addons":{ enableLargeView: false },"height":200,"iid":_vm.currentId,"items":_vm.computedImages,"width":400,"responsive":""},on:{"update:iid":function($event){_vm.currentId=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }